import {UserDto} from "../../client/user/User";
import {formatPersonFirstNameFirst, formatPersonLastNameFirst} from "../person/PersonFormatter";

export function formatUserLastNameFirst(user?: UserDto): string {
    if (!user) {
        return "";
    }
    return user.person ? formatPersonLastNameFirst(user.person) : user.login;
}

export function formatUserFirstNameFirst(user?: UserDto): string {
    if (!user) {
        return "";
    }
    return user.person ? formatPersonFirstNameFirst(user.person) : user.login;
}